/* import __COLOCATED_TEMPLATE__ from './sh-speed-search.hbs'; */
import $ from 'jquery';
import { scheduleOnce } from '@ember/runloop';
import { computed, observer } from '@ember/object';
import Component from '@ember/component';
import RSVP from 'rsvp';

export default Component.extend({

  classNames: 'speed-search',
  classNameBindings: ['hasLabelAndPlaceholder:has-label-and-placeholder'],

  hasLabelAndPlaceholder: computed('placeholder', 'label', function() {
    return this.get('placeholder') && this.get('label');
  }),

  searchModel: undefined,
  searchResultsModel: undefined,
  modelLookupContainer: undefined,
  showSearchResults: false,

  _searchModelWatcher: observer('searchModel,searchModel.length', function () {
    scheduleOnce('afterRender', this, this._setupSearch);
  }),

  _setupSearch: function() {
    let searchModel = this.get('searchModel');
    let self = this;

    $(this.element).find('label').removeClass('active').removeClass('has-text');
    $(this.element).find('input').val('');
    self.set('searchResultsModel', undefined);
    self.set('showSearchResults', false);

    if(!searchModel){
      return;
    }

    RSVP.resolve(searchModel).then(function (searchModel) {
      if (!searchModel.length) {
        self.set('modelLookupContainer', undefined);
        return 0;
      }

      let modelLookupContainer = [];

      [{
        attr: 'firstName',
        lengthLimit: 256
      }, {
        attr: 'lastName',
        lengthLimit: 256
      }, {
        attr: 'fullName',
        lengthLimit: 513
      }, {
        attr: 'location.formattedAddress',
        lengthLimit: 256
      }].forEach(function (attrInfo) {

        let modelLookup = [];

        for (let i = 0; i < attrInfo.lengthLimit; i++) {
          modelLookup[i] = {
            users: [],
            dictionary: []
          };
        }

        let sortFunction = self._sortFunctionGenerator(attrInfo.attr);

        if (!Array.isArray(searchModel)) {
          searchModel = searchModel.toArray();
        }

        // Don't modify the original model -- return a new array
        searchModel = searchModel.slice();

        searchModel.sort(sortFunction);

        searchModel.forEach(function (user) {
          if (!user.get(attrInfo.attr)) {
            return 0;
          }

          let length = user.get(attrInfo.attr).length;
          modelLookup[length].users.push(user);
          modelLookup[length].dictionary.push(user.get(attrInfo.attr));
        });

        modelLookupContainer.push(modelLookup);
      });

      self.set('modelLookupContainer', modelLookupContainer);

    });
  },

  _sortFunctionGenerator: function (stringBasedAttr) {
    return function (a, b) {
      let al = typeof a.get(stringBasedAttr) === 'string' ? a.get(stringBasedAttr).toLowerCase() : a.get(stringBasedAttr);
      let bl = typeof b.get(stringBasedAttr) === 'string' ? b.get(stringBasedAttr).toLowerCase() : b.get(stringBasedAttr);

      if (al < bl) {
        return -1;
      } else if (al > bl) {
        return 1;
      } else {
        return 0;
      }
    };
  },

  init() {
    this._super(...arguments);

    scheduleOnce('afterRender', this, function () {

      // Test for jQuery/DOM instantiation
      if(!this.element){
        return;
      }

      this._setupSearch();

      let self = this;
      let input = $(this.element).find('input');

      input.on('focus', function(e) {
        $(this).parents('label').toggleClass('active', true);
      });

      input.on('blur', function(e) {
        $(this).parents('label').toggleClass('active', false);
      });

      input.on('keyup', function (e) {

        if(self.get('keyupTimeout')) {
          window.clearTimeout(self.get('keyupTimeout'));
        }

        let timeout = setTimeout(function() {
          $(this).parents('label').toggleClass('has-text', ($(this).val().length > 0));

          self.set('searchResultsModel', undefined);
          self.set('showSearchResults', false);

          let modelLookupContainer = self.get('modelLookupContainer');
          if (!modelLookupContainer) {
            return;
          }

          let suggestionIds = new Set();
          let suggestions = [];


          let word = input.val();
          let wordLength = word.length;

          if (wordLength < 1) {
            return 0;
          }

          modelLookupContainer.forEach(function (modelLookup) {
            modelLookup.forEach(function (bin, index) {

              let dictionary = bin.dictionary;

              if ((dictionary.length === 0) || wordLength > index) {
                return 0;
              }

              dictionary = dictionary.join('');

              // Get the number of words in the dictionary bin
              let words = dictionary.length / index,
                // The low point from where we're starting the binary search
                low = 0,
                // The max high point
                high = words - 1,
                // And the precise middle of the search
                mid = Math.floor(words / 2);

              // We continue to look until we reach a final word
              while (high >= low) {
                // Grab the word at our current position
                let found = dictionary.substr(index * mid, index);

                // If we've found the word at the current midpoint, run searches to the left
                // and to the right of the found word so as to capture/find all possible duplicates
                if (word.toLowerCase() === found.substr(0, wordLength).toLowerCase()) {

                  if (!suggestionIds.has(modelLookup[index].users[mid].get('id'))) {
                    suggestionIds.add(modelLookup[index].users[mid].get('id'));
                    suggestions.push(modelLookup[index].users[mid]);
                  }


                  // To the left...
                  let newHigh = mid - 1;
                  while (newHigh >= low) {
                    let newFoundHigh = dictionary.substr(index * newHigh, index);

                    if (word.toLowerCase() === newFoundHigh.substr(0, wordLength).toLowerCase()) {

                      if (!suggestionIds.has(modelLookup[index].users[newHigh].get('id'))) {
                        suggestionIds.add(modelLookup[index].users[newHigh].get('id'));
                        suggestions.push(modelLookup[index].users[newHigh]);
                      }

                      newHigh--; // go down 1 more word and search again
                    } else {
                      newHigh = -1; // jump out
                    }
                  }


                  // And to the right...
                  let newLow = mid + 1;
                  while (high >= newLow) {
                    let newFoundLow = dictionary.substr(index * newLow, index);

                    if (word.toLowerCase() === newFoundLow.substr(0, wordLength).toLowerCase()) {
                      if (!suggestionIds.has(modelLookup[index].users[newLow].get('id'))) {
                        suggestionIds.add(modelLookup[index].users[newLow].get('id'));
                        suggestions.push(modelLookup[index].users[newLow]);
                      }

                      newLow++; // go up one more word and search again
                    } else {
                      high = -1; // jump out
                    }
                  }

                  break;  // If we've found the word and exhausted our left/right searches, we can just break
                          // the loop here without continuing the search
                }

                // Otherwise, compare
                // If we're too high, move lower
                if (word.toLowerCase() < found.substr(0, wordLength).toLowerCase()) {
                  high = mid - 1;

                  // If we're too low, go higher
                } else {
                  low = mid + 1;
                }

                // And find the new search point
                mid = Math.floor((low + high) / 2);
              }

            });
          });

          scheduleOnce('render', this, function() {
            self.set('searchResultsModel', suggestions);
            self.set('showSearchResults', true);
          });


          self.set('keyupTimeout', undefined);
        }.bind(this), 300);

        self.set('keyupTimeout', timeout);


      });
    });
  }
});
